import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../index';
import axios from 'utils/axios';
import { TaskProps } from 'types/props-obj/TaskProps';
const initialState: TaskProps = {
    apiEndPoint: "task",
    isOpen: false,
    pageNumber:1,
    last_page:1,
    pageLimit:5,
    current_page:1,
    total:0,
    list: [],
    item:null,
    error: null,
    alertPopup: false
};
const employeeTask = createSlice({
    name: 'employeeTask',
    initialState,
    reducers: {



        hasError(state, action) {
            state.error = action.payload.error;
        },
        setPageNumber(state, action) {
            state.pageNumber = action.payload;
        },
        setPageLimit(state, action) {
            state.pageLimit = action.payload;
        },
        // get all employeeTask list
        getList(state, action) {
            state.list.push(action.payload);
            const replaceList = state.list.filter((liste) => liste.id != 0);
            state.list = replaceList;
        },
        openToggle(state, action) {

            state.isOpen = action.payload.isOpen;
        },
        // get employeeTask details
        setEmployeeTask(state, action) {
            state.item = action.payload;
        },

        // GET EmployeeTasks
        setEmployeeTasksSuccess(state, action) {
            state.list = action.payload.data;
            state.current_page=action.payload.current_page;
            state.last_page=action.payload.last_page;
            state.total=action.payload.total
        },

        // ADD EmployeeTask
        addEmployeeTaskSuccess(state, action) {
            state.list = [...state.list,action.payload];
        },

        // EDIT EmployeeTask
        editEmployeeTaskSuccess(state, action) {
            var foundIndex = state.list.findIndex(x => x.id == action.payload.id);
            state.item= action.payload;
            state.list[foundIndex] = action.payload;
        },

        deleteEmployeeTaskSuccess(state, action) {
            const deleteData = state.list.filter((item) => item.id !== action.payload);
            state.list = deleteData;
        },

        alertPopupToggle(state, action) {
            state.alertPopup = action.payload.alertPopup;
        }
    }
});
export default employeeTask.reducer;
export const {    getList,setPageNumber,setPageLimit,alertPopupToggle,openToggle} = employeeTask.actions;

export function getEmployeeTasks(params:any={},employeeId:number) {
    return async () => {
        try {
            const response = await axios.get('employee/'+employeeId+'/task',{params:params});
            dispatch(employeeTask.actions.setEmployeeTasksSuccess(response.data));
        } catch (error) {
            dispatch(employeeTask.actions.hasError(error));
        }
    };
}

export function getEmployeeTask(id: number | undefined,employeeId:number) {
    return async () => {
        try {
            const response = await axios.get('employee/'+employeeId+'/task/'+  id);
            dispatch(employeeTask.actions.setEmployeeTask(response.data));
        } catch (error) {
            dispatch(employeeTask.actions.hasError(error));
        }
    };
}

export function addEmployeeTask(ls:any,employeeId:number) {
    return async () => {
        try {
            const response = await axios.post('employee/'+employeeId+'/task', ls);
            dispatch(employeeTask.actions.addEmployeeTaskSuccess(response.data));
        } catch (error) {
            dispatch(employeeTask.actions.hasError(error));
        }
    };
}

export function editEmployeeTask(id: number | undefined,ls: any,employeeId:number) {
    return async () => {
        try {
            const response = await axios.put('employee/'+employeeId+'/task/'+id, ls);
            dispatch(employeeTask.actions.editEmployeeTaskSuccess(response.data));
        } catch (error) {
            dispatch(employeeTask.actions.hasError(error));
        }
    };
}

export function deleteEmployeeTask(id: number | undefined,employeeId:number) {
    return async () => {
        try {
            await axios.delete('employee/'+employeeId+'/task/'+id);
            dispatch(employeeTask.actions.deleteEmployeeTaskSuccess(id));
        } catch (error) {
            dispatch(employeeTask.actions.hasError(error));
        }
    };
}